<template>
    <InformeCard title="Entradas vendidas" style="height: 411px">
        <div class="d-flex" v-if="!isTaquilleroVisitante">
            <Button class="mr-2" :class="isActive(1)" @click="tabId = 1">Métodos de pago</Button>
            <Button v-if="manager.tipo == 1" class="mr-2" :class="isActive(2)" @click="tabId = 2">Entradas Normales y Abonos</Button>
            <Button :class="isActive(3)" @click="tabId = 3">Envíos por Whatsapp</Button>
        </div>
            <EntradasVendidasComponent v-if="tabId == 1" :event_id="event_id" :taquillero_id="taquillero_id" :sesion_id="sesion_id"/>
            <VentasNormalesAbonosComponent v-if="manager.tipo == 1 && tabId == 2 && !isTaquilleroVisitante" :informe_ventas_normal_abonos="informe_ventas_normal_abonos" :event_id="event_id" />
            <GraficoEnviosWhatsapp url="back.events.informe.whatsapp" :params="params" v-if="tabId == 3"></GraficoEnviosWhatsapp>
    </InformeCard>
</template>

<script>
import InformeCard from "../InformeCard";
import EntradasVendidasComponent from '@/components/backend/estadisticas/eventos/EntradasVendidasComponent';
import VentasNormalesAbonosComponent from '@/components/backend/estadisticas/eventos/VentasNormalesAbonosComponent';
import GraficoEnviosWhatsapp from '@/components/backend/estadisticas/eventos/GraficoEnviosWhatsapp';

export default {
    name: "GraficosVentasComponent",
    props: ['event_id', "taquillero_id", "sesion_id", "manager", "informe_ventas_normal_abonos"],
    components: { InformeCard, EntradasVendidasComponent, VentasNormalesAbonosComponent, GraficoEnviosWhatsapp },
    data() {
        return {
            tabId: 1,
            params: {
                filters: {
                    sesion_id: this.sesion_id
                },
                evento_id: this.event_id
            }
        }
    },
    computed:{
        isTaquilleroVisitante() {
            return this.$store.getters.getUser.role === 11;
        },
    },
    methods: {
        isActive(tabId) {
            return { "active": this.tabId == tabId };
        }
    }
}
</script>